import ArBaseContainer from 'src/components/ArBaseContainer/ArBaseContainer'
import PropTypes from 'prop-types'
import React from 'react'
import { media } from 'src/styles/styled-components'
import styled from 'styled-components'

const StyledWrapper = styled.section`
  background-color: ${ ({ theme }) => theme.colors.backgroundArPartners } ;
  color: ${ ({ theme }) => theme.colors.white } ;
  padding-bottom: 10px;
  padding-top: 20px;

  ${ media.tablet`
    padding-top: 60px;
    padding-bottom: 60px;
  ` }
`

const StyledContainer = styled(ArBaseContainer)`
  /* ${ media.tablet` */
    /* margin-bottom: 0; */
  /* ` } */
`

const StyledHeading = styled.h2`
  font-size: 1.8rem;
  font-weight: ${ ({ theme }) => theme.fontWeight.primary.Light };
  line-height: 1.6;
  margin-bottom: 25px;
  text-align: center; 

  ${ media.tablet`
    font-size: 2.2rem;
  ` }

  ${ media.desktop`
    font-size: 2.8rem;
  ` }
`

const StyledList = styled.div`
  align-items: flex-end;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 auto;

  ${ media.tablet`
    align-items: center;
  justify-content: space-between;
    max-width: 660px;
  ` }

  ${ media.desktop`
    align-items: flex-end;
    justify-content: space-around;
    max-width: 1080px;
  ` }
`

const StyledLogo = styled.img`
  margin: 0 10px 25px;
  width: auto;
  
  @media (max-width: 577px) {
    &:nth-of-type(1) {
      max-height: 40px;
    }
    &:nth-of-type(2) {
      max-height: 40px;
      order: 1;
      width: 30%;
    }
    &:nth-of-type(3) {
      margin-left: 10%;
      margin-right: 10%;
      max-height: 40px;
    }
    &:nth-of-type(4) {
      max-height: 32px;
    }
    &:nth-of-type(5) {
      margin-bottom: 16px;
      max-height: 40px;
      width: 30%;
    }
  }

  ${ media.tablet`
    margin: 0;
    /* width: 25%; */

    &:nth-of-type(1) {
      max-height: 40px;
    }
    &:nth-of-type(2) {
      order: 0;
      max-height: 45px;
      margin-top: -7px;
    }
    &:nth-of-type(3) {
      max-height: 32px;
    }
    &:nth-of-type(4) {
      max-height: 32px;
    }
    &:nth-of-type(5) {
      max-height: 32px;
    }
  ` }

  ${ media.desktop`
    &:nth-of-type(1) {
      max-height: 57px;
    }
    &:nth-of-type(2) {
      max-height: 55px;
      margin-top: -10px;
    }
    &:nth-of-type(3) {
      max-height: 77px;
    }
    &:nth-of-type(4) {
      max-height: 40px;
    }
    &:nth-of-type(5) {
      max-height: 40px;
    }
  ` }
`

class ArPartners extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    logos: PropTypes.array,
  }

  render () {
    const { title, logos } = this.props
    return (
      <StyledWrapper>
        <StyledContainer>
          <StyledHeading>{ title }</StyledHeading>

          <StyledList>
            {logos.map(({ url, alt }, index) =>
              <React.Fragment key={index}>
                <StyledLogo src={url} alt={alt}></StyledLogo>
              </React.Fragment>
            )}
          </StyledList>
        </StyledContainer>
      </StyledWrapper>
    )
  }
}

export default ArPartners
